<template>
  <div class="app-shell">
    <router-view />
    <footer class="site-footer">
      Tüm hakları Deep Erdek Cafe Restaurant'a aittir.
    </footer>
  </div>
</template>

<style>
@import url("https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;600;700&display=swap");

:root {
  --bg-900: #061225;
  --bg-850: #081a33;
  --bg-800: #0b2342;
  --bg-700: #0f2f59;
  --card: #0b1f3a;
  --card-strong: #0f2b4f;
  --accent: #49b6ff;
  --accent-strong: #2f7bff;
  --text: #e7f1ff;
  --muted: #9fb2cc;
}

html,
body {
  margin: 0;
  background: radial-gradient(1200px 600px at 20% -10%, #153a72 0%, var(--bg-900) 45%) no-repeat,
    linear-gradient(160deg, var(--bg-900), var(--bg-800));
  background-repeat: no-repeat;
  background-size: cover, cover;
  background-attachment: scroll;
  background-color: var(--bg-900);
  color: var(--text);
  font-family: "Space Grotesk", "Segoe UI", system-ui, sans-serif;
}
html,
body,
#app {
  height: 100%;
  min-height: 100%;
}
.app-shell {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
.site-footer {
  margin-top: auto;
  padding: 14px 16px 22px;
  text-align: center;
  color: var(--muted);
  font-size: 12px;
  letter-spacing: 0.6px;
}
</style>
